export default {"src":"/_next/static/media/delivery.81e9087f.svg","height":137,"width":170,"blurWidth":0,"blurHeight":0};